// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DividerHeadline_wrapper__A0pEQ","headline":"DividerHeadline_headline__khkDT","square":"DividerHeadline_square__nRXW9"};